import { MdDelete, MdModeEditOutline } from "react-icons/md";

const PlainDish = (props) => {

    return (
        <div>
            <div className="d-flex">
                <div>
                    <strong>
                    { props.data.name }
                    </strong>
                </div>
                &nbsp;&nbsp;
                <strong>-</strong>
                &nbsp;&nbsp;
                <div>
                    <strong>
                    Q. &nbsp; { props.data.price }
                    </strong>
                </div>
                <div className="d-flex">
                    <button onClick={() => props.callback.edit(props.data)} className='cbtn-md d-inline-block mx-1'>
                        <MdModeEditOutline pointerEvents='none' />
                    </button>
                    <button onClick={() => props.callback.delete(props.data)} className='cbtn-md d-inline-block'>
                        <MdDelete pointerEvents='none' />
                    </button>
                </div>
            </div>
            <div className="tx-alt">
                { props.data.description }
            </div>
        </div>
    );
}

export default PlainDish;